import React from 'react';
import { useStaticQuery, graphql } from 'gatsby';
import Img from 'gatsby-image';

const ImgEmailMarketing = ({ className }) => {
  const data = useStaticQuery(graphql`
    query ImgEmailMarketingQ {
      image: file(relativePath: { eq: "images/services-email-marketing.jpg" }) {
        id
        childImageSharp {
          fluid(quality: 90, maxWidth: 1920) {
            ...GatsbyImageSharpFluid_withWebp
          }
        }
      }
    }
  `);

  return (
    <Img
      fluid={data.image.childImageSharp.fluid}
      alt="seo & web design digital marketing services - email marketing"
      className={className}
    />
  );
};

export default ImgEmailMarketing;
